// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Table,
  Thead,
  Tr,
  Td,
  Tbody,
  Th,
  Progress,
  Spacer,
  Text,
  useColorMode,
  useColorModeValue,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Link
} from "@chakra-ui/react";
import { pageVisits, socialTraffic } from "variables/general";

// Assets
import BackgroundCard1 from "assets/img/guide.jpg";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import React from "react";
import { getGlobal } from "config/global";
import config from "config/index";

import { AspectRatio } from '@chakra-ui/react'

function Guide() {
  // Chakra color mode
  const iconBlue = useColorModeValue("blue.500", "blue.500");
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("#dee2e6", "transparent");
  const tableRowColor = useColorModeValue("#dee2e6", "transparent");
  const textTableColor = useColorModeValue("#dee2e6", "transparent");
  const { colorMode } = useColorMode();
  let me = getGlobal("me")
  let list =
    [
      {
        title: "ساخت اولین تور مجازی",
        text: <>
          <video width={"100%"} controls>
            <source src={config.panelhost + "/videos/1.mp4"} type="video/mp4"/>
                Your browser does not support the video tag.
              </video>
            </>
      },
            {
              title: "ساخت ایستگاه برای تور مجازی",
            text: "در حال ساخت ..."
      },
            {
              title: "اضافه کردن مارکر به ایستگاه",
            text: "در حال ساخت ..."
      },
            {
              title: "رادیو نمایشگاه",
            text: "در حال ساخت ..."
      },
            {
              title: "منوی اختصاصی به ازای هر ایستگاه",
            text: "در حال ساخت ..."
      },
            {
              title: "ارتقای پلن",
            text: "در حال ساخت ..."
      },
            {
              title: "آپلود و استفاده از فایل",
            text: "در حال ساخت ..."
      }
            ]

            return (
            <Flex direction='column' pt={{ base: "120px", md: "75px" }}>
              <Grid templateColumns={{ sm: "1fr", lg: "2fr 1.2fr" }} templateRows='1fr'>
                <Box>
                  <Grid
                    templateColumns={{
                      sm: "1fr",
                      md: "1fr 1fr",
                      xl: "1fr 1fr",
                    }}
                    templateRows={{ sm: "auto auto", md: "1fr auto", xl: "1fr" }}
                    gap='26px'>
                    <Card
                      backgroundImage={
                        colorMode === "dark"
                          ? BackgroundCard1
                          : BackgroundCard1
                      }
                      backgroundRepeat='no-repeat'
                      background='contain'
                      backgroundSize="100% auto"
                      bgPosition='50% 50%'
                      p='16px'
                      h={{ sm: "220px", xl: "100%" }}
                      gridArea={{ md: "1 / 1 / 2 / 3", xl: "1 / 1 / 2 / 3" }}>
                      <CardBody h='100%' w='100%'>
                        <Flex
                          direction='column'
                          color='white'
                          h='220px'
                          p='0px 10px 20px 10px'
                          w='100%'>
                          <Flex justify='space-between' align='center'>

                          </Flex>
                          <Spacer />
                          <Flex direction='column'>

                          </Flex>
                        </Flex>
                      </CardBody>
                    </Card>
                  </Grid>
                  <Card p='16px' mt='24px'>
                    <CardHeader>
                    </CardHeader>
                    <CardBody>
                    <Text textAlign={"justify"} fontSize={"sm"} mt="10px" lineHeight={"30px"}>
                        <Text as="span" color={"green.300"}>
                          تــور مجــازی ترنـــج
                        </Text>{"، "}
                        مکانی است که شما می‌توانید به سرعت و به سهولت، نمایشگاه مجازی خود را ایجاد کرده و تجربه‌ شگفت‌انگیزی از دنیای مجازی را تجربه کنید. 
                        <br />
                        جهت آموزش ساده پنل کاربری، ویدیوهایی آماده شده است که در بخش "راهنمای تصویری" قابل دسترسی است. در آنها سعی شده است که همه موارد مورد نیاز با زبانی گویا و روان توضیح داده شود.
                        <br/>
                        در هر بخش سوالی داشتید یا به مشکلی برخوردید، کافی است از طریق بخش پشتیبانی با ما در ارتباط باشید.
                      </Text>
                    </CardBody>
                  </Card>
                  <Card p='16px' mt='24px'>

                    <Grid>
                      <Text fontSize='md' color={textColor} fontWeight='bold'>
                        نکاتی برای کاربری آسان‌تر
                      </Text>
                      <Text  textAlign={"justify"} fontSize={"sm"} mt="10px" lineHeight={"30px"} >
                        پیشنهاد می‌شود ابتدا فایل‌های مورد نظر را آپلود کرده، سپس نمایشگاه را ساخته و تنظیمات مربوطه را انجام دهید. پس از آن برای ساخت منو و پاپ آپ که می‌تواند در ایستگاه‌ها مورد استفاده قرار بگیرد اقدام کنید. حال وقت ساخت ایستگاه‌ها، آپلود پانوراما، لوگو و ایجاد مارکرهاست.
                        <br/>
                        آپلود فایل {" > "} ساخت نمایشگاه {" > "} ساخت پاپ آپ {" > "} ساخت منو {" > "} ساخت ایستگاه ها {" > "} ساخت مارکرها
                      </Text>
                    </Grid>
                  </Card>
                </Box>
                <Card
                  p='22px'
                  my={{ sm: "24px", lg: "0px" }}
                  ms={{ sm: "0px", lg: "24px" }}>
                  <CardHeader>
                    <Flex justify='space-between' align='center' mb='1rem' w='100%'>
                      <Text fontSize='lg' color={textColor} fontWeight='bold'>
                        راهنمای تصویری
                      </Text>
                    </Flex>
                  </CardHeader>
                  <CardBody>
                    <Grid w='100%'>
                      <Accordion allowToggle defaultIndex={[0]}>
                        {list.map((row, idx) => {
                          return (
                            <AccordionItem>
                              <AccordionButton>
                                <Box flex='1' textAlign='right' p={"5px 0px 5px 0px"}>
                                  <Text fontSize={"sm"} color={textColor}>
                                    {row.title}
                                  </Text>
                                </Box>
                                <AccordionIcon />
                              </AccordionButton>
                              <AccordionPanel pb={4}>
                                <Text p={"5px 20px 10px 0px"} fontSize={"xs"}>
                                  {row.text}
                                </Text>
                              </AccordionPanel>
                            </AccordionItem>
                          );
                        })}
                      </Accordion>

                    </Grid>
                  </CardBody>
                </Card>
              </Grid>

            </Flex>
            );
}

            export default Guide;
